import { VueExtension } from '../../utils/extensions/vue';
import PickerColumn from './pickercolumn.jsx';
import './pickercolumn.scss';

VueExtension.WithInstall(PickerColumn);

export default PickerColumn;
